
/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {FetchOptions} from 'ofetch';
import type {
  BriefResource,
  CancelQuoteRequest,
  DeleteQuoteRequest,
  ExtendQuoteValidityRequest,
  FetchQuoteContextRequest,
  QuoteAmountSummaryRequest,
  QuoteAmountSummaryResource,
  QuoteContextResource,
  QuoteRequest,
  QuoteResource,
  QuoteTemplateResource,
  SendQuoteRequest,
  SendQuoteResource,
  UpdateQuoteFreelancerExternalReferenceRequest,
} from '../models';
import {
    BriefResourceFromJSON,
    BriefResourceToJSON,
    CancelQuoteRequestFromJSON,
    CancelQuoteRequestToJSON,
    DeleteQuoteRequestFromJSON,
    DeleteQuoteRequestToJSON,
    ExtendQuoteValidityRequestFromJSON,
    ExtendQuoteValidityRequestToJSON,
    FetchQuoteContextRequestFromJSON,
    FetchQuoteContextRequestToJSON,
    QuoteAmountSummaryRequestFromJSON,
    QuoteAmountSummaryRequestToJSON,
    QuoteAmountSummaryResourceFromJSON,
    QuoteAmountSummaryResourceToJSON,
    QuoteContextResourceFromJSON,
    QuoteContextResourceToJSON,
    QuoteRequestFromJSON,
    QuoteRequestToJSON,
    QuoteResourceFromJSON,
    QuoteResourceToJSON,
    QuoteTemplateResourceFromJSON,
    QuoteTemplateResourceToJSON,
    SendQuoteRequestFromJSON,
    SendQuoteRequestToJSON,
    SendQuoteResourceFromJSON,
    SendQuoteResourceToJSON,
    UpdateQuoteFreelancerExternalReferenceRequestFromJSON,
    UpdateQuoteFreelancerExternalReferenceRequestToJSON,
} from '../models';

export interface AmendQuoteRequest {
    freelancerQuoteId: string;
    quoteRequest: QuoteRequest;
}

export interface CancelQuoteOperationRequest {
    freelancerQuoteId: string;
    cancelQuoteRequest?: CancelQuoteRequest;
}

export interface CreateDraftQuoteRequest {
    quoteRequest: QuoteRequest;
}

export interface DeleteQuoteOperationRequest {
    freelancerQuoteId: string;
    deleteQuoteRequest?: DeleteQuoteRequest;
}

export interface ExtendQuoteValidityOperationRequest {
    freelancerQuoteId: string;
    extendQuoteValidityRequest?: ExtendQuoteValidityRequest;
}

export interface FetchQuoteContextOperationRequest {
    fetchQuoteContextRequest: FetchQuoteContextRequest;
}

export interface GetBriefDetailRequest {
    briefId: string;
}

export interface GetConversationBriefDetailRequest {
    conversationId: string;
}

export interface GetQuoteRequest {
    freelancerQuoteId: string;
}

export interface GetQuoteAmountSummaryRequest {
    quoteAmountSummaryRequest: QuoteAmountSummaryRequest;
}

export interface GetQuoteByCorrelationIdRequest {
    correlationId: string;
}

export interface GetQuoteTemplatesRequest {
    projectId?: string;
}

export interface SendQuoteOperationRequest {
    freelancerQuoteId: string;
    sendQuoteRequest?: SendQuoteRequest;
}

export interface UpdateDraftQuoteRequest {
    freelancerQuoteId: string;
    quoteRequest: QuoteRequest;
}

export interface UpdateQuoteFreelancerExternalReferenceOperationRequest {
    freelancerQuoteId: string;
    updateQuoteFreelancerExternalReferenceRequest: UpdateQuoteFreelancerExternalReferenceRequest;
}

/**
 * 
 */
export class ProjectFreelancerQuoteApi extends runtime.BaseAPI {

    /**
     * Update a submitted quote (amend it)
          */
    async amendQuoteRaw(requestParameters: AmendQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['freelancerQuoteId'] == null) {
            throw new runtime.RequiredError(
                'freelancerQuoteId',
                'Required parameter "freelancerQuoteId" was null or undefined when calling amendQuote().'
            );
        }

        if (requestParameters['quoteRequest'] == null) {
            throw new runtime.RequiredError(
                'quoteRequest',
                'Required parameter "quoteRequest" was null or undefined when calling amendQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-freelancer/api/quote/{freelancerQuoteId}`.replace(`{${"freelancerQuoteId"}}`, encodeURIComponent(String(requestParameters['freelancerQuoteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: QuoteRequestToJSON(requestParameters['quoteRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update a submitted quote (amend it)
          */
    async amendQuote(requestParameters: AmendQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.amendQuoteRaw(requestParameters, initOverrides);
    }

    /**
     * Cancel a quote
          */
    async cancelQuoteRaw(requestParameters: CancelQuoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['freelancerQuoteId'] == null) {
            throw new runtime.RequiredError(
                'freelancerQuoteId',
                'Required parameter "freelancerQuoteId" was null or undefined when calling cancelQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-freelancer/api/quote/{freelancerQuoteId}/cancel`.replace(`{${"freelancerQuoteId"}}`, encodeURIComponent(String(requestParameters['freelancerQuoteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CancelQuoteRequestToJSON(requestParameters['cancelQuoteRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Cancel a quote
          */
    async cancelQuote(requestParameters: CancelQuoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.cancelQuoteRaw(requestParameters, initOverrides);
    }

    /**
     * Create a draft quote
          */
    async createDraftQuoteRaw(requestParameters: CreateDraftQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<QuoteResource>> {
        if (requestParameters['quoteRequest'] == null) {
            throw new runtime.RequiredError(
                'quoteRequest',
                'Required parameter "quoteRequest" was null or undefined when calling createDraftQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<QuoteResource>({
            path: `/project-freelancer/api/quote/draft`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QuoteRequestToJSON(requestParameters['quoteRequest']),
        }, initOverrides);

        if (response._data) { response._data=QuoteResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Create a draft quote
          */
    async createDraftQuote(requestParameters: CreateDraftQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<QuoteResource> {
        const response = await this.createDraftQuoteRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Delete a quote
          */
    async deleteQuoteRaw(requestParameters: DeleteQuoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['freelancerQuoteId'] == null) {
            throw new runtime.RequiredError(
                'freelancerQuoteId',
                'Required parameter "freelancerQuoteId" was null or undefined when calling deleteQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-freelancer/api/quote/{freelancerQuoteId}`.replace(`{${"freelancerQuoteId"}}`, encodeURIComponent(String(requestParameters['freelancerQuoteId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: DeleteQuoteRequestToJSON(requestParameters['deleteQuoteRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Delete a quote
          */
    async deleteQuote(requestParameters: DeleteQuoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteQuoteRaw(requestParameters, initOverrides);
    }

    /**
     * Extend the validity of an expired quote
          */
    async extendQuoteValidityRaw(requestParameters: ExtendQuoteValidityOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['freelancerQuoteId'] == null) {
            throw new runtime.RequiredError(
                'freelancerQuoteId',
                'Required parameter "freelancerQuoteId" was null or undefined when calling extendQuoteValidity().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-freelancer/api/quote/{freelancerQuoteId}/extend-validity`.replace(`{${"freelancerQuoteId"}}`, encodeURIComponent(String(requestParameters['freelancerQuoteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ExtendQuoteValidityRequestToJSON(requestParameters['extendQuoteValidityRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Extend the validity of an expired quote
          */
    async extendQuoteValidity(requestParameters: ExtendQuoteValidityOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.extendQuoteValidityRaw(requestParameters, initOverrides);
    }

    /**
     * Fetch a quote context
          */
    async fetchQuoteContextRaw(requestParameters: FetchQuoteContextOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<QuoteContextResource>> {
        if (requestParameters['fetchQuoteContextRequest'] == null) {
            throw new runtime.RequiredError(
                'fetchQuoteContextRequest',
                'Required parameter "fetchQuoteContextRequest" was null or undefined when calling fetchQuoteContext().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<QuoteContextResource>({
            path: `/project-freelancer/api/quote/context`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FetchQuoteContextRequestToJSON(requestParameters['fetchQuoteContextRequest']),
        }, initOverrides);

        if (response._data) { response._data=QuoteContextResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Fetch a quote context
          */
    async fetchQuoteContext(requestParameters: FetchQuoteContextOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<QuoteContextResource> {
        const response = await this.fetchQuoteContextRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get the brief detail by its id
          */
    async getBriefDetailRaw(requestParameters: GetBriefDetailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<BriefResource>> {
        if (requestParameters['briefId'] == null) {
            throw new runtime.RequiredError(
                'briefId',
                'Required parameter "briefId" was null or undefined when calling getBriefDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<BriefResource>({
            path: `/project-freelancer/api/brief/{briefId}`.replace(`{${"briefId"}}`, encodeURIComponent(String(requestParameters['briefId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=BriefResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get the brief detail by its id
          */
    async getBriefDetail(requestParameters: GetBriefDetailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<BriefResource> {
        const response = await this.getBriefDetailRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get the brief detail of a conversation
     
     * @deprecated
          */
    async getConversationBriefDetailRaw(requestParameters: GetConversationBriefDetailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<BriefResource>> {
        if (requestParameters['conversationId'] == null) {
            throw new runtime.RequiredError(
                'conversationId',
                'Required parameter "conversationId" was null or undefined when calling getConversationBriefDetail().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<BriefResource>({
            path: `/project-freelancer/api/conversation/{conversationId}/brief`.replace(`{${"conversationId"}}`, encodeURIComponent(String(requestParameters['conversationId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=BriefResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get the brief detail of a conversation
     
     * @deprecated
          */
    async getConversationBriefDetail(requestParameters: GetConversationBriefDetailRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<BriefResource> {
        const response = await this.getConversationBriefDetailRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get a quote
          */
    async getQuoteRaw(requestParameters: GetQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<QuoteResource>> {
        if (requestParameters['freelancerQuoteId'] == null) {
            throw new runtime.RequiredError(
                'freelancerQuoteId',
                'Required parameter "freelancerQuoteId" was null or undefined when calling getQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<QuoteResource>({
            path: `/project-freelancer/api/quote/{freelancerQuoteId}`.replace(`{${"freelancerQuoteId"}}`, encodeURIComponent(String(requestParameters['freelancerQuoteId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=QuoteResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get a quote
          */
    async getQuote(requestParameters: GetQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<QuoteResource> {
        const response = await this.getQuoteRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get a quote amount summary (currencies, fees, etc) even before a draft is created
          */
    async getQuoteAmountSummaryRaw(requestParameters: GetQuoteAmountSummaryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<QuoteAmountSummaryResource>> {
        if (requestParameters['quoteAmountSummaryRequest'] == null) {
            throw new runtime.RequiredError(
                'quoteAmountSummaryRequest',
                'Required parameter "quoteAmountSummaryRequest" was null or undefined when calling getQuoteAmountSummary().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<QuoteAmountSummaryResource>({
            path: `/project-freelancer/api/quote/amount-summary`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: QuoteAmountSummaryRequestToJSON(requestParameters['quoteAmountSummaryRequest']),
        }, initOverrides);

        if (response._data) { response._data=QuoteAmountSummaryResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get a quote amount summary (currencies, fees, etc) even before a draft is created
          */
    async getQuoteAmountSummary(requestParameters: GetQuoteAmountSummaryRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<QuoteAmountSummaryResource> {
        const response = await this.getQuoteAmountSummaryRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get a quote by correlation id
          */
    async getQuoteByCorrelationIdRaw(requestParameters: GetQuoteByCorrelationIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<QuoteResource>> {
        if (requestParameters['correlationId'] == null) {
            throw new runtime.RequiredError(
                'correlationId',
                'Required parameter "correlationId" was null or undefined when calling getQuoteByCorrelationId().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['correlationId'] != null) {
            queryParameters['correlationId'] = requestParameters['correlationId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<QuoteResource>({
            path: `/project-freelancer/api/quote`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        if (response._data) { response._data=QuoteResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Get a quote by correlation id
          */
    async getQuoteByCorrelationId(requestParameters: GetQuoteByCorrelationIdRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<QuoteResource> {
        const response = await this.getQuoteByCorrelationIdRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Get templates for a quote based on existing quotes of a freelancer. Can filter only for quotes associated to project
          */
    async getQuoteTemplatesRaw(requestParameters: GetQuoteTemplatesRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<Array<QuoteTemplateResource>>> {
        const queryParameters: any = {};

        if (requestParameters['projectId'] != null) {
            queryParameters['projectId'] = requestParameters['projectId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request<Array<QuoteTemplateResource>>({
            path: `/project-freelancer/api/quote/templates`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        response._data=response._data?.map(QuoteTemplateResourceFromJSON);
        return response;
    }

    /**
     * Get templates for a quote based on existing quotes of a freelancer. Can filter only for quotes associated to project
          */
    async getQuoteTemplates(requestParameters: GetQuoteTemplatesRequest = {}, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<Array<QuoteTemplateResource>> {
        const response = await this.getQuoteTemplatesRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Create a submitted quote, sent it to the client and purge the draft quote
          */
    async sendQuoteRaw(requestParameters: SendQuoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<SendQuoteResource>> {
        if (requestParameters['freelancerQuoteId'] == null) {
            throw new runtime.RequiredError(
                'freelancerQuoteId',
                'Required parameter "freelancerQuoteId" was null or undefined when calling sendQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<SendQuoteResource>({
            path: `/project-freelancer/api/quote/draft/{freelancerQuoteId}`.replace(`{${"freelancerQuoteId"}}`, encodeURIComponent(String(requestParameters['freelancerQuoteId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SendQuoteRequestToJSON(requestParameters['sendQuoteRequest']),
        }, initOverrides);

        if (response._data) { response._data=SendQuoteResourceFromJSON(response._data); }
        return response;
    }

    /**
     * Create a submitted quote, sent it to the client and purge the draft quote
          */
    async sendQuote(requestParameters: SendQuoteOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<SendQuoteResource> {
        const response = await this.sendQuoteRaw(requestParameters, initOverrides);
        return response._data;
    }

    /**
     * Update a draft quote
          */
    async updateDraftQuoteRaw(requestParameters: UpdateDraftQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['freelancerQuoteId'] == null) {
            throw new runtime.RequiredError(
                'freelancerQuoteId',
                'Required parameter "freelancerQuoteId" was null or undefined when calling updateDraftQuote().'
            );
        }

        if (requestParameters['quoteRequest'] == null) {
            throw new runtime.RequiredError(
                'quoteRequest',
                'Required parameter "quoteRequest" was null or undefined when calling updateDraftQuote().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-freelancer/api/quote/draft/{freelancerQuoteId}`.replace(`{${"freelancerQuoteId"}}`, encodeURIComponent(String(requestParameters['freelancerQuoteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: QuoteRequestToJSON(requestParameters['quoteRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update a draft quote
          */
    async updateDraftQuote(requestParameters: UpdateDraftQuoteRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateDraftQuoteRaw(requestParameters, initOverrides);
    }

    /**
     * Update the freelancer external reference
          */
    async updateQuoteFreelancerExternalReferenceRaw(requestParameters: UpdateQuoteFreelancerExternalReferenceOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<runtime.FetchResponse<void>> {
        if (requestParameters['freelancerQuoteId'] == null) {
            throw new runtime.RequiredError(
                'freelancerQuoteId',
                'Required parameter "freelancerQuoteId" was null or undefined when calling updateQuoteFreelancerExternalReference().'
            );
        }

        if (requestParameters['updateQuoteFreelancerExternalReferenceRequest'] == null) {
            throw new runtime.RequiredError(
                'updateQuoteFreelancerExternalReferenceRequest',
                'Required parameter "updateQuoteFreelancerExternalReferenceRequest" was null or undefined when calling updateQuoteFreelancerExternalReference().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        const response = await this.request<void>({
            path: `/project-freelancer/api/quote/{freelancerQuoteId}/freelancerExternalReference`.replace(`{${"freelancerQuoteId"}}`, encodeURIComponent(String(requestParameters['freelancerQuoteId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateQuoteFreelancerExternalReferenceRequestToJSON(requestParameters['updateQuoteFreelancerExternalReferenceRequest']),
        }, initOverrides);

        return response;
    }

    /**
     * Update the freelancer external reference
          */
    async updateQuoteFreelancerExternalReference(requestParameters: UpdateQuoteFreelancerExternalReferenceOperationRequest, initOverrides?: FetchOptions | runtime.InitOverrideFunction): Promise<void> {
        await this.updateQuoteFreelancerExternalReferenceRaw(requestParameters, initOverrides);
    }

}
